export default __webpack_public_path__ + "static/media/inventory-kit-sub-tier-green.12a0c70f.svg";